import React from 'react';
import './UserPhotoCell.css';

function initials(name?: string): string {
  const s = (name || '?').trim();
  const parts = s.split(/\s+/).filter(Boolean);
  if (parts.length >= 2) return (parts[0][0] + parts[1][0]).toUpperCase();
  return s.slice(0, 2).toUpperCase();
}

type UserPhotoCellProps = {
  name?: string;
  photoUrl?: string | null;
  size?: 'sm' | 'md';
};

const UserPhotoCell: React.FC<UserPhotoCellProps> = ({ name, photoUrl, size = 'sm' }) => (
  <div className={`user-photo-cell user-photo-cell--${size}`}>
    {photoUrl ? (
      <img src={photoUrl} alt="" className="user-photo-cell__img" />
    ) : (
      <span className="user-photo-cell__placeholder" aria-hidden>
        {initials(name)}
      </span>
    )}
  </div>
);

export default UserPhotoCell;
